<!-- Button Block -->
<button
	[class]="buttonClass"
	#dropdownButton
	(click)="toggle()"
>
	<span><ng-content></ng-content></span>
	<ng-fa-icon icon="angle-down"></ng-fa-icon>
</button>

<!-- dropdown menu block -->
<div
	[class]="menuClass"
	#dropdownMenu
	[class.d-none]="!hasOpen"
>
	<button
		[class]="menuOptionClass"
		[class.active]="value === option.code"
		*ngFor="let option of options"
		(click)="selectOption(option)"
	>
		{{ option.label }}
	</button>
</div>
